import * as React from 'react';
import { Checkbox, CheckboxProps } from '../inputs/Checkbox';
import { FormField } from './FormField';

type CheckboxFieldProps = CheckboxProps & {
    label:string
};

export function CheckboxField(props:CheckboxFieldProps)
{
    return (
        <FormField 
            label=""
            inputComponent={
                <div style={{height:'40px', display:'flex', alignItems:'center'}}>
                    <Checkbox 
                        text={props.label} 
                        value={props.value} 
                        checked={props.checked}
                        onChange={props.onChange} />
                </div>
            }
            inErrorState={false}
            message=""
        />
    )
}